const Eating = () => (
  <h1>Eating</h1>
);

export default Eating;
